import listActions from 'src/modules/subTarea/list/subTareaListActions';
import SubTareaService from 'src/modules/subTarea/subTareaService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'SUBTAREA_DESTROY';

const subTareaDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: subTareaDestroyActions.DESTROY_STARTED,
      });

      await SubTareaService.destroyAll([id]);

      dispatch({
        type: subTareaDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.subTarea.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/sub-tarea');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: subTareaDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: subTareaDestroyActions.DESTROY_ALL_STARTED,
      });

      await SubTareaService.destroyAll(ids);

      dispatch({
        type: subTareaDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.subTarea.destroyAll.success'),
      );

      getHistory().push('/sub-tarea');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: subTareaDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default subTareaDestroyActions;
